import { render, staticRenderFns } from "./NewsDialog.vue?vue&type=template&id=da212920&scoped=true"
import script from "./NewsDialog.vue?vue&type=script&lang=js"
export * from "./NewsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da212920",
  null
  
)

export default component.exports